define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "dojo/i18n!nls/mldoStringResource",
    "mw-filename-utils/FileNameUtil"
], function (declare, Action, MLDOStrings, FileNameUtil) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        var context = args.context;
        var makeActionAvailable = args.showAction || false;
        this.name =  "runAction";
        this.enabled = makeActionAvailable;
        this.getInvitationDetailsMethod = args.getInvitationDetailsMethod;
        this.label = MLDOStrings.contextMenuRunLabel;
        this.section = {
          id: "MISC",
          name: "MISC",
          allowSubMenu: false,
          forceSubMenu: false
        };
        this.isApplicableTo = function () {
            let fileInfo;
            let selectedFileCount = context.getSelectedRowCount();
            if (!context.isRunEnabled()) {
                return false;
            }
            if (selectedFileCount !== 1) {
                this.enabled = false;
            } else {
                fileInfo = context.getSelectedItemFileInfos()[0];
                if (!fileInfo.isDirectory && context.RUN_SUPPORTED_TYPES.includes(FileNameUtil.getFileNameExtension(fileInfo.name).toLowerCase())) {
                    this.enabled = true;
                } else {
                    this.enabled = false;
                }

            }
            return this.enabled;
        };
        this.callback = function () {
          if (this.isApplicableTo()) {
            let invitationDetails;
            if (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function" && this.getInvitationDetailsMethod()) {
                invitationDetails = this.getInvitationDetailsMethod();
            }
            let fileInfo = context.getSelectedItemFileInfos()[0];
            context.handleRunAction(fileInfo.path, fileInfo, invitationDetails.authenticated, invitationDetails.invitationId,
                invitationDetails.invitationName, invitationDetails.invitationTombstoneId);
          }
        };
    }
  });

});
